import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/mentorship";

export const mentorshipApi = {
  createProfile: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/profiles`, body),

  updateProfile: (body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`${BASE}/profiles`, body),

  listProfiles: () => apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/profiles`),

  searchProfiles: (skills?: string, available?: boolean) => {
    const searchParams = new URLSearchParams();
    if (skills) searchParams.set("skills", skills);
    if (available !== undefined) searchParams.set("available", String(available));
    return apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/profiles/search?${searchParams.toString()}`);
  },

  getProfile: (userId: string) => apiGet<{ data: Record<string, unknown> }>(`${BASE}/profiles/${userId}`),

  sendRequest: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/requests`, body),

  listRequests: (direction?: string) => {
    const searchParams = new URLSearchParams();
    if (direction) searchParams.set("direction", direction);
    return apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/requests?${searchParams.toString()}`);
  },

  updateRequest: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`${BASE}/requests/${id}`, body),

  createSession: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/sessions`, body),

  listSessions: (requestId?: string) => {
    const searchParams = new URLSearchParams();
    if (requestId) searchParams.set("requestId", requestId);
    return apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/sessions?${searchParams.toString()}`);
  },

  updateSession: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`${BASE}/sessions/${id}`, body),

  completeSession: (id: string) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/sessions/${id}/complete`),

  createGoal: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/goals`, body),

  listGoals: (requestId: string) => apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/goals/${requestId}`),

  updateGoal: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`${BASE}/goals/${id}`, body),

  completeGoal: (id: string) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/goals/${id}/complete`),

  createFeedback: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/feedback`, body),

  listFeedback: () => apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/feedback`),

  bulkDeleteRequests: (requestIds: string[]) => apiDelete<{ data: number }>(`${BASE}/requests/bulk-delete`, { data: { requestIds } }),

  bulkDeleteSessions: (sessionIds: string[]) => apiDelete<{ data: number }>(`${BASE}/sessions/bulk-delete`, { data: { sessionIds } }),

  bulkDeleteGoals: (goalIds: string[]) => apiDelete<{ data: number }>(`${BASE}/goals/bulk-delete`, { data: { goalIds } }),

  bulkDeleteFeedback: (feedbackIds: string[]) => apiDelete<{ data: number }>(`${BASE}/feedback/bulk-delete`, { data: { feedbackIds } }),

  getStats: () => apiGet<{ data: Record<string, unknown> }>(`${BASE}/mentorship/stats`),

  export: (type = "requests", format = "CSV") => apiGet<{ data: unknown }>(`${BASE}/mentorship/export?type=${type}&format=${format}`),
};